module.exports = __webpack_public_path__ + "static/img/MS.a094d82f.svg";